import { CARD_TYPES } from "../../constants/editor";

import type { CardType } from "../../shared/game";

type TypePickerProps = {
  typeLabel: CardType["label"];
  onSelect: (typeLabel: CardType["label"]) => void;
  disabled?: boolean;
};

export function TypePicker({ typeLabel, onSelect, disabled = false }: TypePickerProps) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(6, minmax(0, 1fr))", gap: 6 }}>
      {CARD_TYPES.map((entry) => (
        <button
          key={entry.label}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(entry.label)}
          style={{
            width: "100%",
            height: 34,
            borderRadius: 8,
            border: `2px solid ${typeLabel === entry.label ? entry.color : "rgba(255,255,255,0.08)"}`,
            color: typeLabel === entry.label ? entry.color : "#7c8399",
            background: typeLabel === entry.label ? `${entry.color}1b` : "rgba(255,255,255,0.02)",
            fontSize: 14,
            opacity: disabled ? 0.5 : 1,
          }}
        >
          {entry.label.split(" ")[0]}
        </button>
      ))}
    </div>
  );
}
